import React from 'react';

import { Container, Content, Text, Title } from "../../../componentes/Interface";

export default function _400({ erro }: any) {
  const mensagemErro = (function () {
    if (erro === 'expired') return 'expirado'
    return 'inválido'
  })()

  return (
    <Container>
      <Content full verticalCenter horizontalCenter padding>
        <Title gutterBottom>400</Title>
        <Text gutterBottom align='center'>
          Ops... página com link {mensagemErro}!
        </Text>
      </Content>
    </Container>
  );
}
